import { useEffect, useState } from 'react';
// import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getLoginInfo, validateTrinetKeys, storeNewConfig } from '../api'
import Button from 'react-bootstrap/Button';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import DevaltusfrontImg from '../images/devaltusfront3_flat.png';

function UserInfo(props) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [vacationCalendar, setVacationCalendar] = useState(false);
    const [hrCalendar, setHrCalendar] = useState(false);
    const [payrollCalendar, setPayrollCalendar] = useState(false);
    const [trinetClientId, setTrinetClientId] = useState('');
    const [trinetClientSecret, setTrinetClientSecret] = useState('');
    const [trinetCompanyId, setTrinetCompanyId] = useState('');
    const [buttonDisable, setButtonDisable] = useState(true);
    // const [validated, setValidated] = useState(false);
    const [isInvalid, setIsInvalid] = useState(false);


    const [trinetInfoValid, setTrinetInfoValid] = useState(false);
    // const [calendars, setCalendars] = useState();
    // const navigate = useNavigate();
    const { getIdTokenClaims } = useAuth0();

    useEffect(() => {
        if (trinetClientId && trinetClientSecret && trinetCompanyId) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }

    }, [trinetClientId, trinetClientSecret, trinetCompanyId]);

    const setTrinetFields = (name, value) => {
        if (name === 'trinetClientId') {
            setTrinetClientId(value);
        } else if (name === 'trinetClientSecret') {
            setTrinetClientSecret(value);
        } else if (name === 'trinetCompanyId') {
            setTrinetCompanyId(value);
        }
    }

    const handleValidate = async () => {
        getLoginInfo('');
        const result = await validateTrinetKeys({
            trinetClientId,
            trinetClientSecret,
            trinetCompanyId
        });
        if (result.valid) {
            setTrinetInfoValid(result.valid);
        } else {
            props.handleMessage({ type: "error", message: result.error });
            setIsInvalid(true);
        }

    }
    const handleSave = async () => {
        const userData = {
            trinetClientId,
            trinetClientSecret,
            trinetCompanyId,
            contactEmail: email,
            contactName: name,
            companyName: companyName,
            vacationCalendar,
            hrCalendar,
            payrollCalendar

        }
        const { __raw: id_token } = await getIdTokenClaims();
        const result = await storeNewConfig(userData, id_token);
        if (result) {
            // navigate('/calendar');
            // setCalendars(result);
            props.getCalenderAfterSave(result);
        }
    }

    return (
        <>
            <div>
                <Row style={{ margin: 0 }}>
                    <Col md={8}>
                        <Form noValidate >
                            {trinetInfoValid ?
                                <>
                                    <Form.Group as={Row} className="mb-3" controlId="formTrinetClientId">
                                        <Form.Label column sm={10}>
                                            User Details
                                        </Form.Label>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formName">
                                        <Form.Label column sm={4}>
                                            Name
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="formName">
                                        <Form.Label column sm={4}>
                                            Email
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Form.Control type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="formCompanyName">
                                        <Form.Label column sm={4}>
                                            Company Name
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Form.Control type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                                        </Col>
                                    </Form.Group>
                                    {/* <Form.Group as={Row} className="mb-3" controlId="formCompanyPhone">
                                    <Form.Label column sm={4}>
                                        Company Phone
                                    </Form.Label>
                                    <Col sm={4}>
                                        <Form.Control type="text" value={companyPhone} onChange={(e) => setCompanyPhone(e.target.value)} />
                                    </Col>
                                </Form.Group> */}

                                    <Form.Group as={Row} className="mb-3" controlId="formCompanyPhone">
                                        <Form.Label column sm={4}>
                                            Vacation Calendar
                                        </Form.Label>
                                        <Col sm={1}>
                                            <Form.Check label="" value={vacationCalendar} onChange={(e) => setVacationCalendar(e.target.checked)} />

                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formCompanyPhone">
                                        <Form.Label column sm={4}>
                                            HR Calendar
                                        </Form.Label>
                                        <Col sm={1}>
                                            <Form.Check label="" value={hrCalendar} onChange={(e) => setHrCalendar(e.target.checked)} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formCompanyPhone">
                                        <Form.Label column sm={4}>
                                            Payroll Calendar
                                        </Form.Label>
                                        <Col sm={1}>
                                            <Form.Check label="" value={payrollCalendar} onChange={(e) => setPayrollCalendar(e.target.checked)} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3">
                                        <Col sm={{ span: 8, offset: 2 }}>
                                            <Button variant="secondary" onClick={handleSave} >Save</Button>
                                        </Col>
                                    </Form.Group>
                                </>
                                :
                                <>
                                    <Form.Group as={Row} className="mb-3" controlId="formTrinetClientId">
                                        <Form.Label column sm={10}>
                                            Trinet Details
                                        </Form.Label>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="formTrinetClientId">
                                        <Form.Label column sm={4}>
                                            Trinet Client Id
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Form.Control type="text" value={trinetClientId} onChange={(e) => setTrinetFields('trinetClientId', e.target.value)} isInvalid={isInvalid} />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid ClientId.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formTrinetClientSecret">
                                        <Form.Label column sm={4}>
                                            Trinet Client Secret
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Form.Control type="text" value={trinetClientSecret} onChange={(e) => setTrinetFields('trinetClientSecret', e.target.value)} isInvalid={isInvalid} />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid Client Secret.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formTrinetUsername">
                                        <Form.Label column sm={4}>
                                            Trinet Company Id
                                        </Form.Label>
                                        <Col sm={4}>
                                            <Form.Control type="text" value={trinetCompanyId} onChange={(e) => setTrinetFields('trinetCompanyId', e.target.value)} isInvalid={isInvalid} />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid Company Id.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Col sm={{ span: 8, offset: 2 }}>
                                            <Button variant="secondary" onClick={handleValidate} disabled={buttonDisable}>Validate</Button>
                                        </Col>
                                    </Form.Group>
                                </>
                            }
                        </Form>
                    </Col>
                    <Col>
                        <Image src={DevaltusfrontImg} fluid height={'auto'} width={'auto'} />
                    </Col>
                </Row>
            </div>

        </>
    );
}

export default UserInfo;